export const FirebaseConfig = {
	"projectId": "courier24-46f2a",
	"appId": "1:956598500605:web:b87e32a5b044be779e5294",
	"databaseURL": "https://courier24-46f2a-default-rtdb.firebaseio.com",
	"storageBucket": "courier24-46f2a.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyBBWny1qRiVm6pmsav9rPd1ukmLB1WoPas",
	"authDomain": "courier24-46f2a.firebaseapp.com",
	"messagingSenderId": "956598500605",
	"measurementId": "G-PZY5HEPEJD"
};